import { motion } from "framer-motion";
import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../components/Footer/Footer";
import PageTop from "../components/PageTop/PageTop";
import Spacer from "../components/Utils/Spacer";
import { Context } from "../context";

const Privacy = () => {
  const { debug, lang } = useContext(Context);

  return (
    <>
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4 }}
      >
        <title>Privacy - davidebalice.dev</title>
        <PageTop pageTitle="" />

        <Container className="text-justify privacy-page">
          <Row>
            <Col>
              <Spacer height={60} />

              {lang === "en" && (
                <>
                  <h2>Privacy policy of www.davidebalice.dev</h2>

                  <p>
                    The term Application refers to this same website
                    www.davidebalice.dev and all the demos connected to it
                    published on third-level domains with the extension
                    demo-name.davidebalice.dev.
                  </p>

                  <br />

                  <p>
                    This Application collects some personal data of its Users
                    only and exclusively on the contact page of the main
                    website.
                    <br />
                    This data will be used exclusively to respond to any emails
                    received.
                    <br />
                    The data is not stored for marketing purposes or for any
                    other purpose other than responding to the email received.
                    <br />
                    <br />
                    We do not use third-party tracking systems such as Google
                    Analitycs, Facebook Pixel, Microsoft Clarity or similar.
                    <br />
                    No data is provided to third parties.
                    <br />
                    No data will be used for insertions in Mailing lists or
                    similar.
                  </p>

                  <br />

                  <h2 id="owner_of_the_data">Data controller</h2>

                  <p>Davide Balice</p>
                  <p>
                    <strong>Data controller email:</strong>{" "}
                    davide.balice@gmail.com
                  </p>

                  <br />

                  <h2>Types of data collected</h2>

                  <p>The data collected are: Name and Email.</p>

                  <br />

                  <h2>Treatment modalities</h2>
                  <p>
                    The Owner adopts appropriate security measures to prevent
                    unauthorized access, disclosure, modification or destruction
                    of Personal Data. <br />
                    The processing is carried out using computer and/or
                    telematic tools, with organizational methods and with logic
                    strictly related to the purposes indicated.
                  </p>

                  <br />

                  <h2>Location</h2>

                  <p>
                    The Data is processed at the Data Controller's operating
                    offices and in any other place where the parties involved in
                    the processing are located. For further information, contact
                    the Data Controller.
                  </p>

                  <br />

                  <h2>Retention period</h2>
                  <p>
                    Personal data is processed and stored for the time necessary
                    to process and send a response to the email received.
                  </p>

                  <br />

                  <h2 id="use_collected_data">
                    Purpose of the Processing of Collected Data
                  </h2>

                  <p>
                    User Data is collected to allow the Owner to provide
                    responses to requests received.
                  </p>

                  <br />
                  <br />
                </>
              )}

              {lang === "it" && (
                <>
                  <h2>Privacy policy di www.davidebalice.dev</h2>

                  <p>
                    Con il termine Applicazione si intende questo stesso sitoweb
                    www.davidebalice.dev e tutte le demo ad esso collegate
                    pubblicate su domini di terzo livello con estensione
                    nome-demo.davidebalice.dev.
                  </p>

                  <br />

                  <p>
                    Questa Applicazione raccoglie alcuni dati personali dei
                    propri Utenti solo ed eslusivamente nella pagina contatti
                    del sito web principale.
                    <br />
                    Questi dati verranno utilizzati esclusivamente per
                    rispondere ad eventuali mail pervenute.
                    <br />
                    I dati non sono archiviati per scopi di marketing o per
                    qualsiasi altro scopo che non sia rispondere alla mail
                    ricevuta.
                    <br />
                    <br />
                    Non si utilizzano sistemi di tracciamento di terze parti
                    quali Google Analitycs, Facebook Pixel, Microsoft Clarity o
                    similari.
                    <br />
                    Nessuna dato viene fornito a terze parti.
                    <br />
                    Nessun dato verrà utilizzato per inserimenti in Mailing list
                    o similari.
                  </p>

                  <br />

                  <h2 id="owner_of_the_data">
                    Titolare del trattamento dei dati
                  </h2>

                  <p>Davide Balice</p>
                  <p>
                    <strong>Indirizzo email del Titolare:</strong>{" "}
                    davide.balice@gmail.com
                  </p>

                  <br />

                  <h2>Tipologie di dati raccolti</h2>

                  <p>I dati raccolti sono: Nome e Email.</p>

                  <br />

                  <h2>Modalit&agrave; di trattamento</h2>
                  <p>
                    Il Titolare adotta le opportune misure di sicurezza volte ad
                    impedire l’accesso, la divulgazione, la modifica o la
                    distruzione non autorizzate dei Dati Personali. <br />
                    Il trattamento viene effettuato mediante strumenti
                    informatici e/o telematici, con modalità organizzative e con
                    logiche strettamente correlate alle finalità indicate.
                  </p>

                  <br />

                  <h2>Luogo</h2>

                  <p>
                    I Dati sono trattati presso le sedi operative del Titolare
                    ed in ogni altro luogo in cui le parti coinvolte nel
                    trattamento siano localizzate. Per ulteriori informazioni,
                    contatta il Titolare.
                  </p>

                  <br />

                  <h2>Periodo di conservazione</h2>
                  <p>
                    I dati personali sono trattati e conservati per il tempo
                    necessario ad elaborare ed inviare una risposta alla mail
                    ricevuta.
                  </p>

                  <br />

                  <h2 id="use_collected_data">
                    Finalità del Trattamento dei Dati raccolti
                  </h2>

                  <p>
                    I Dati dell'Utente sono raccolti per consentire al Titolare
                    di fornire risposta alle richieste ricevute.
                  </p>

                  <br />
                  <br />
                </>
              )}
            </Col>
          </Row>
        </Container>

        <Footer />
      </motion.main>
    </>
  );
};

export default Privacy;
